import { supabase } from "../lib/supabase";

const API_BASE = process.env.REACT_APP_API_BASE || "";

async function authHeaders() {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) {
    throw new Error("Bitte melde dich an.");
  }
  return { Authorization: `Bearer ${token}` };
}

/**
 * One open payload. Returns null when this API is not deployed yet.
 * @returns {Promise<null | {
 *   items: object[],
 *   household?: { id?: string|null, linked?: boolean },
 *   hasMail?: boolean,
 *   schoolDates?: object[],
 *   nearHolidays?: object[],
 *   greeting?: { kind?: string, date?: string, chatText?: string, sections?: object[] }|null,
 * }>}
 */
export async function fetchHome() {
  const headers = await authHeaders();
  const res = await fetch(`${API_BASE}/api/home`, { headers, cache: "no-store" });
  if (res.status === 404) return null;
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Laden fehlgeschlagen (${res.status}).`);
  }
  return data;
}
